
import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { getSchema } from '../../decorators/utilities/get.merge.schema';
import { MergeField } from '../../decorators/decorators/merge.field';
import { MergeSchema } from '../../decorators/decorators/merge.schema';

@MergeSchema({
    entity: ActivityEntityName.Site
})

export class BasicSiteMergeData {

    @MergeField()
    street: string;

    @MergeField()
    street2: string;

    @MergeField()
    suburb: string;

    @MergeField()
    state: string;

    @MergeField()
    postcode: string;

    @MergeField()
    postalCode: string;

    @MergeField()
    county: string;

    @MergeField()
    country: string;

    @MergeField()
    fullAddress: string;

    @MergeField()
    name: string;

    customFields?: any;
}

export const BasicSiteMergeSchema = getSchema(BasicSiteMergeData);